import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Link } from '@americanexpress/dls-react';
import styles from './Footer.scss';

const Footer = ({ linkHref = '#' }) => {
  const intl = useIntl();

  return (
    <div className={styles.footer}>
      <Link href={linkHref}>
        {intl.formatMessage({ id: 'passkeyRegistration.onlinePrivacyStatement' })}
      </Link>
    </div>
  );
};

Footer.propTypes = {
  linkHref: PropTypes.string,
};

export default Footer;
